import Footer from "../components/Footer";
import Header from "../components/Header";

const Contact = () => {
  return (
    <div>
      <div>
        <Header />
        <section className="relative">
          <div className="container">
            <div className="w-full">
              <img
                src={require("../assets/images/background2.jpg")}
                alt="contact-us"
                className="absolute w-full right-0 left-0 h-full"
              />
              <div
                className="pointer-events-none absolute left-0 top-0 h-full w-full"
                style={{
                  background:
                    "linear-gradient(180deg, rgba(17, 23, 41, 0.6) 0%, rgba(32, 41, 58, 0.1) 100%)",
                }}
              ></div>
              <div className="relative flex min-h-[27rem] items-center md:min-h-[25.5rem]">
                <div className="items-left flex w-full flex-col">
                  <h1 className="uppercase font-oswald break-words text-4xl md:text-4xl px-8 font-medium mb-4 text-white text-left">
                    Contact us
                  </h1>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="my-16 md:my-24" style={{}}>
          <div className="container">
            <div className="px-8">
              <div className="md:grid md:grid-cols-3 md:gap-6">
                <div className="mb-8 md:hidden">
                  <p className="font-oswald break-words text-2xl md:text-2xl uppercase font-bold mb-2 text-grey-600">
                    HEADQUARTERS
                  </p>
                  <h2 className="uppercase font-oswald break-words text-3xl md:text-4xl font-medium text-blue-800">
                    NYRIRENDAS COMPANY
                  </h2>
                </div>
                <img
                  className="bg-blue-800 mb-8 rounded-2xl md:col-span-2 md:item-center md:mb-0 w-full md:order-1"
                  src={require("../assets/images/sido.jpg")}
                  alt="NYIREDAS COMPANY"
                />
                <div className="md:item-center">
                  <div className="mb-8 mt-8 hidden md:block">
                    <p className="font-popping break-words space-x-4 md:space-x-6 uppercase font-bold mb-2 text-grey-600">
                      HEADQUARTERS
                    </p>
                    <h2 className="uppercase font-oswald break-words md:text-4xl font-medium text-blue-800">
                      NYIRENDAS COMPANY
                    </h2>
                  </div>
                  <div className="mb-6 flex items-center ">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" className="mr-2 size-6 shrink-0 text-blue-700"><path fill-rule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clip-rule="evenodd"></path></svg>
                      
                    <p className="font-poppins break-words text-xl font-normal hidden md:block">
                      SIDO, BL-149, Vingunguti, Dar es salaam
                    </p>
                    <a
                      href=""
                      target="_blank"
                      rel="noopener noreferrer"
                      className="relative inline-block rounded-sm text-blue-600 ring-blue-600 ring-offset-2 ring-offset-white focus:outline-none focus-visible:ring-2 active:outline-none dark:text-blue-800 dark:ring-white dark:ring-offset-black before:absolute before:right-0 before:bottom-0 before:h-px before:w-0 before:bg-blue-600 before:duration-200 before:hover:left-0 hover:before:w-full dark:before:bg-white text-left md:hidden"
                    >
                      SIDO BL.19, Nyerere Rd, Vingunguti, Dar es Salaam
                    </a>
                  </div>
                  <div className="mb-8 flex">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      aria-hidden="true"
                      className="mr-2 size-6 shrink-0 text-blue-700"
                    >
                      <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"></path>
                    </svg>
                    <a
                      href="tel:+255755481857"
                      className="relative inline-block rounded-sm text-blue-600 ring-blue-600 ring-offset-2 ring-offset-white focus:outline-none focus-visible:ring-2 active:outline-none dark:text-blue-800 dark:ring-white dark:ring-offset-black before:absolute before:right-0 before:bottom-0 before:h-px before:w-0 before:bg-blue-600 before:duration-200 before:hover:left-0 hover:before:w-full dark:before:bg-white"
                    >
                      +255 789 1056 06
                    </a>
                  </div>
                  <button
                    className="font-oswald flex justify-center items-center rounded font-medium py-3 px-4 text-lg leading-6 w-full focus-within:[&amp;:not(:disabled)]:outline focus:[&amp;:not(:disabled)]:outline active:[&amp;:not(:disabled)]:outline focus-within:outline-2 focus:outline-2 active:outline-2 uppercase transition-colors duration-200 group-[.fixed]:transform group-[.fixed]:rotate-180 group-[.fixed]:rounded-l-none group-[.fixed]:px-3 group-[.fixed]:py-4 bg-blue-800 text-white hover:bg-blue-600 focus-within:outline-electric-500 focus:outline-electric-500 active:outline-electric-500 focus-within:bg-blue-600 focus:bg-blue-600 active:bg-blue-600 group-[.fixed]:md:px-4 group-[.fixed]:md:py-6 md:py-4 md:px-6 md:w-auto"
                    type="button"
                  >
                    <span className="inline-flex [&amp;+*]:pl-2">
                      Contact Us
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </div>
  );
};

export default Contact;
